<div
    ngGrid
    [rendererOptions]="_tableData?.rendererOpts"
    [selectTemplate]="_tableData?.selectTpl"
    [rows]="_tableData?.rows"
    [sortDefs]="_tableData?.sortDefs"
    (willInflate)="_onWillInflate()"
    (didInflate)="_onDidInflate()"
>
    <ng-template
        gridContent
        data-type="grid"
    >
        <div></div>
    </ng-template>

    <ng-template
        gridContent
        data-type="row"
        data-id="bundle"
    >
        <div class="cmps-mi2-table--row-bundle"></div>
    </ng-template>

    <ng-template
        gridContent
        data-type="cell"
        data-id="bundle"
        let-c="c"
        let-ctx="ctx"
    >
        <div [ngSwitch]="c.id">
            <div
                class="cmps-mi2-table--row-bundle--pad1"
                *ngSwitchCase="'bundle-left'"
            ></div>
            <div
                class="cmps-mi2-table--row-bundle--mi2-score"
                *ngSwitchCase="'bundle-a'"
            ></div>
            <div
                class="cmps-mi2-table--row-bundle--pad2"
                *ngSwitchCase="'bundle-b'"
            ></div>
            <div
                class="cmps-mi2-table--row-bundle--current"
                *ngSwitchCase="'bundle-c'"
            >
                <span class="cmps-mi2-table--row--text">{{
                    _i18n._758_CURRENT_SCORECARD | translate
                }}</span>
            </div>
            <div
                class="cmps-mi2-table--row-bundle--previous"
                *ngSwitchCase="'bundle-d'"
            >
                <span class="cmps-mi2-table--row--text">{{
                    _i18n._756_PREVIOUS_SCORECARD | translate
                }}</span>
            </div>
            <div
                class="cmps-mi2-table--row-bundle--pad1"
                *ngSwitchCase="'bundle-e'"
            ></div>
        </div>
    </ng-template>

    <ng-template
        gridContent
        data-type="row"
        data-id="header"
    >
        <div class="cmps-mi2-table--row-header"></div>
    </ng-template>

    <ng-template
        gridContent
        data-type="cell"
        data-id="header"
        let-c="c"
        let-ctx="ctx"
    >
        <div>
            <div
                [ngClass]="
                    'cmps-mi2-table--row-header--' + ctx?.data?.classSuffix
                "
            >
                <button
                    class="cmps-mi2-table--row-header--button"
                    (click)="columnSortClick.emit({ c: ctx?.data })"
                >
                    <span class="cmps-mi2-table--row--text">{{
                        ctx?.data?.label | translate
                    }}</span>
                    <cmps-icon
                        [svgIcon]="
                            sortOptions?.order === 'asc'
                                ? 'chevron-up'
                                : 'chevron-down'
                        "
                        [hidden]="sortOptions?.columnId !== ctx?.data?.id"
                    ></cmps-icon>
                </button>
            </div>
        </div>
    </ng-template>

    <ng-template
        gridContent
        data-type="row"
        data-id="content"
    >
        <div class="cmps-mi2-table--row"></div>
    </ng-template>

    <ng-template
        gridContent
        data-type="cell"
        data-id="content"
        let-c="c"
        let-ctx="ctx"
    >
        <div [ngSwitch]="c.id">
            <div
                class="cmps-mi2-table--row--performer"
                *ngSwitchCase="_ColumnId.PERFORMER"
            >
                <cmps-icon
                    class="cmps-mi2-table--user-icon"
                    svgIcon="account-circle"
                ></cmps-icon>
                <span class="cmps-mi2-table--row--text">{{
                    ctx?.data?.name
                }}</span>
            </div>
            <div
                class="cmps-mi2-table--row--mi2-score"
                *ngSwitchCase="_ColumnId.MI2_SCORE"
            >
                <span class="cmps-mi2-table--row--text">{{
                    ctx?.data?.mi2Score == null
                        ? '-'
                        : (ctx?.data?.mi2Score / 100 | cmpsPercent: '1.0-0')
                }}</span>
            </div>
            <div
                class="cmps-mi2-table--row--improvement-category"
                *ngSwitchCase="_ColumnId.IMPROVEMENT_CATEGORY"
            >
                <button
                    class="cmps-mi2-main--improvement-category-button"
                    cmpsButton
                    [style.background-color]="
                        ctx?.data?.improvementGroup?.colour
                    "
                    (click)="
                        showTrendClick.emit({
                            r: ctx?.data,
                            key: _TrendDialogMode.IMPROVEMENT
                        })
                    "
                >
                    <span
                        class="cmps-mi2-table--row--text"
                        cmpsButtonLabel
                        >{{
                            ctx?.data?.improvementGroup
                                ?.scorecardImprovementGroupName
                        }}</span
                    >
                </button>
            </div>
            <div
                class="cmps-mi2-table--row--oa-score"
                *ngSwitchCase="_ColumnId.OA_SCORE"
            >
                <span class="cmps-mi2-table--row--text">{{
                    ctx?.data?.oaScore == null
                        ? '-'
                        : (ctx?.data?.oaScore / 100 | cmpsPercent: '1.0-0')
                }}</span>
            </div>
            <div
                class="cmps-mi2-table--row--mi2-plus-score"
                *ngSwitchCase="_ColumnId.MI2_PLUS_SCORE"
            >
                <span class="cmps-mi2-table--row--text">{{
                    ctx?.data?.mi2PlusScore == null
                        ? '-'
                        : (ctx?.data?.mi2PlusScore / 100 | cmpsPercent: '1.2-2')
                }}</span>
            </div>
            <div
                class="cmps-mi2-table--row--scorecard-points"
                *ngSwitchCase="_ColumnId.SCORECARD_POINTS"
            >
                <span class="cmps-mi2-table--row--text">{{
                    ctx?.data?.scorecardPoints == null
                        ? '-'
                        : (ctx?.data?.scorecardPoints | cmpsNumber: '1.2-2')
                }}</span>
            </div>
            <div
                class="cmps-mi2-table--row--scorecard-performance-class"
                *ngSwitchCase="_ColumnId.SCORECARD_PERFORMANCE_CLASS"
            >
                <button
                    class="cmps-button--no-bg cmps-mi2-main--category-button"
                    cmpsButton
                    (click)="
                        showTrendClick.emit({
                            r: ctx?.data,
                            key: _TrendDialogMode.SCORECARD
                        })
                    "
                >
                    <div
                        class="cmps-mi2-main--category-button--bar"
                        [style.background-color]="
                            ctx?.data?.performanceClass?.colour
                        "
                    ></div>
                    <span
                        class="cmps-mi2-table--row--text"
                        cmpsButtonLabel
                        >{{
                            ctx?.data?.performanceClass
                                ?.scorecardPerformanceClassName | translate
                        }}</span
                    >
                    <cmps-icon
                        class="cmps-mi2-main--category-button--icon"
                        svgIcon="chevron-right"
                    ></cmps-icon>
                </button>
            </div>
            <div
                class="cmps-mi2-table--row--previous-scorecard-points"
                *ngSwitchCase="_ColumnId.PREVIOUS_SCORECARD_POINTS"
            >
                <span class="cmps-mi2-table--row--text">{{
                    ctx?.data?.previousScorecardPoints == null
                        ? '-'
                        : (ctx?.data?.previousScorecardPoints
                          | cmpsNumber: '1.2-2')
                }}</span>
            </div>
            <div
                class="cmps-mi2-table--row--previous-scorecard-performance-class"
                *ngSwitchCase="_ColumnId.PREVIOUS_SCORECARD_PERFORMANCE_CLASS"
            >
                <button
                    class="cmps-button--no-bg cmps-mi2-main--category-button"
                    cmpsButton
                    (click)="
                        showTrendClick.emit({
                            r: ctx?.data,
                            key: _TrendDialogMode.SCORECARD
                        })
                    "
                >
                    <div
                        class="cmps-mi2-main--category-button--bar"
                        [style.background-color]="
                            ctx?.data?.previousPerformanceClass?.colour
                        "
                    ></div>
                    <span
                        class="cmps-mi2-table--row--text"
                        cmpsButtonLabel
                        >{{
                            ctx?.data?.previousPerformanceClass
                                ?.scorecardPerformanceClassName | translate
                        }}</span
                    >
                    <cmps-icon
                        class="cmps-mi2-main--category-button--icon"
                        svgIcon="chevron-right"
                    ></cmps-icon>
                </button>
            </div>
            <div
                class="cmps-mi2-table--row--improvement-achieved"
                *ngSwitchCase="_ColumnId.IMPROVEMENT_ACHIEVED"
            >
                <span class="cmps-mi2-table--row--text">{{
                    ctx?.data?.improvementAchieved == null
                        ? '-'
                        : (ctx?.data?.improvementAchieved / 100
                          | cmpsPercent: '1.2-2')
                }}</span>
            </div>
            <div
                class="cmps-mi2-table--row--movement-of-ranking"
                *ngSwitchCase="_ColumnId.MOVEMENT_OF_RANKING"
            >
                <cmps-icon
                    [ngClass]="ctx?.data?.movementOfRankingClass"
                    [svgIcon]="ctx?.data?.movementOfRankingIcon"
                ></cmps-icon>
                <span class="cmps-mi2-table--row--text">{{
                    _i18n._9865___NUM___POSITIONS
                        | translate: { num: ctx?.data?.movementOfRankingAbs }
                }}</span>
            </div>
        </div>
    </ng-template>
</div>
